<template>
  <div>
    <div class="container-fluid" style="zoom: 80%">
      <div class="row">
        <div class="col-md-12 mb-2">
          <h3 style="font-weight:700">Account Settings</h3>
        </div>
        <Sidebar />
        <div class="col-md-10 pl-0" v-if="status">
          <div class="card card-box mb-3 " style="border-radius : 0%; height: 97.5%;">
            <div class="card-body">
              <b-form>
                <div class="row">
                  <div class="col-md-12 mt-2 mb-3">
                    <h4 class="__blue" style="font-weight: 700">
                      Skema Komisi
                    </h4>
                  </div>
                  <div class="col-md-12">
                    <b-form-group label="Skema Komisi dihitung berdasarkan:" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                        id="radio-inline-1"
                        v-model="selectedKomisi"
                        :options="[]"
                        :aria-describedby="ariaDescribedby"
                        name="radio-inline"
                        :disabled="btnDisable"
                      >
                        <b-form-radio class="skema-komisi" value="pre">
                          <b-alert show variant="dark" class="alert-skema-komisi alert-radio-label my-0">Harga Sebelum Diskon</b-alert>
                        </b-form-radio>
                        <b-form-radio class="skema-komisi" value="post">
                          <b-alert show variant="dark" class="alert-skema-komisi alert-radio-label my-0">Harga Setelah Diskon</b-alert>
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                  <div class="col-md-8">
                    <b-alert show variant="dark" class="alert-skema-komisi" v-if="selectedKomisi === 'pre'">
                      <p>Contoh perhitungan:</p>
                      <p class="p-skema-komisi"><b>HARGA SEBELUM DISKON</b></p>
                      <p class="p-skema-komisi">- harga tindakan A Rp15.000 dan mendapatkan diskon 1% sehingga total tindakan Rp14.850</p>
                      <p class="p-skema-komisi">- skema komisi perawat 1%</p>
                      <p class="p-skema-komisi">- maka perhitungan komisi perawat tersebut adalah 1%*Rp15.000 = Rp150</p>
                    </b-alert>
                    <b-alert show variant="dark" class="alert-skema-komisi" v-else-if="selectedKomisi === 'post'">
                      <p>Contoh perhitungan:</p>
                      <p class="p-skema-komisi"><b>HARGA SETELAH DISKON</b></p>
                      <p class="p-skema-komisi">- harga tindakan A Rp15.000 dan mendapatkan diskon 1% sehingga total tindakan Rp14.850</p>
                      <p class="p-skema-komisi">- skema komisi perawat 1%</p>
                      <p class="p-skema-komisi">- maka perhitungan komisi perawat tersebut adalah 1%*Rp14.850 = Rp149</p>
                    </b-alert>
                  </div>
                  <div class="col-md-12 mt-5 mb-3">
                    <b-button
                      variant="primary"
                      v-if="!btnDisable"
                      class="float-right"
                      @click="onSubmit"
                      >SIMPAN</b-button
                    >
                    <b-button
                      variant="primary"
                      v-if="btnDisable"
                      @click="btnDisable = false"
                      class="float-right"
                      >EDIT DATA</b-button
                    >
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import startCase from "lodash/startCase";

export default {
  components: {
    Sidebar: () => import("@/views/AccountSettingKlinik/Sidebar"),
  },
  data: () => {
    return {
      selectedKomisi: null,
      status: false,
      btnDisable: true,
    };
  },
  mounted() {
    this.getProfile()

    window.scrollTo({
      top: 95,
      behavior: "smooth"
    });
  },
  computed: {
    ...mapGetters(["getKlinikId"])
  },
  methods: {
    onCancel() {
      this.getProfile()
    },
    onSubmit() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: 'btn btn-info',
          cancelButton: 'btn btn-danger mr-2'
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons.fire({
        type: "warning",
        html: '<p class="m-0" style="font-size: 13px;">Apakah Anda yakin akan mengubah Skema Komisi?</p>',
        showCancelButton: true,
        confirmButtonText: 'Simpan',
        cancelButtonText: 'Batal',
        reverseButtons: true,
      }).then((res) => {
        if (res.value) {
          this.submit();
        }
        this.btnDisable = true;
        this.getProfile();
      });
    },
    async submit() {
        const res = await axios.post(`${this.url_api}/klinik/komisi-type`,
          {
            klinik_id: this.getKlinikId,
            komisi_formula_type: this.selectedKomisi,
          }
        );
        const { data, status } = res.data;
        if (status) {
          this.selectedKomisi = data.komisi_formula_type;
          this.btnDisable = true;
          this.$swal({
            type: "success",
            text: startCase("skema komisi berhasil disimpan")
          });
        } else {
          this.$swal({
            type: "error",
            text: startCase("skema komisi gagal disimpan")
          });
        }
    },
    async getProfile() {
      try {
        let profile;
        this.$store.state.klinikUser.map(data => {
          if (data.parent_id != null && data.id == this.getKlinikId) {
            profile = data.parent_id;
          }
        });
        const res = await axios.get(
          `${this.url_api}/klinik/${this.getKlinikId}?klinik_id=${profile}&profile=true`
        );
        const { data } = res.data;
        this.selectedKomisi = data.komisi_formula_type;
        this.btnDisable = true;
        this.status = true;
      } catch (e) {}
    },
  }
};
</script>

<style>
  .col-form-label {
    margin-bottom: 20px;
  }
</style>

<style scoped>
  .__blue {
    color: #4b80b6;
  }

  .alert {
    border-radius: 5px;
  }

  .alert-radio-label {
    padding: 0.75rem 2rem;
    margin-right: 50px;
  }

  .alert-skema-komisi {
    background-color: #eeeff8;
    opacity: 1;
    top: -10px;
  }

  .p-skema-komisi {
    margin: 0;
  }
</style>